// skills/woodcutting/index.js
// Woodcutting skill registration with skill registry

import { skillRegistry } from '../../core/skillRegistry.js';
import { renderWoodcuttingUI, updateWoodcuttingUI, initWoodcuttingUI, toggleChopping, upgradeAxe } from './woodcuttingUI.js';

/**
 * Woodcutting skill configuration
 */
const woodcuttingConfig = {
    id: 'woodcutting',
    name: 'Woodcutting',
    icon: '🪓',
    iconImage: 'assets/icons/skill_icons/woodcutting.png',
    description: 'Chop down trees for logs',

    tabs: [
        { id: 'trees', name: 'Trees', default: true },
    ],

    render(params = {}) {
        renderWoodcuttingUI();
    },

    update() {
        updateWoodcuttingUI();
    },

    init() {
        initWoodcuttingUI();
    },

    cleanup() {
        // Nothing to cleanup for now
    }
};

skillRegistry.register('woodcutting', woodcuttingConfig);

if (typeof window !== 'undefined') {
    window.woodcuttingUI = {
        toggleChopping,
        upgradeAxe
    };
}

export default woodcuttingConfig;
